import './index.scss'
import React, { useRef, useImperativeHandle, forwardRef, useEffect, useCallback } from 'react'
import { useDebounceFn } from 'ahooks'
import { FloatButton } from 'antd'

const ScrollLoad = forwardRef(({ children, onReachBottom, loading, loadFinish }, ref) => {

  const scrollLoadRef = useRef(null)
  const scrollWrapRef = useRef(null)
  const backTopRef = useRef(null)
  const loadingRef = useRef(loading)
  const loadFinishRef = useRef(loadFinish)
  const onReachBottomRef = useRef(onReachBottom)

  // 保持 ref 的值是最新的
  useEffect(() => {
    loadingRef.current = loading
  }, [loading])

  useEffect(() => {
    loadFinishRef.current = loadFinish
  }, [loadFinish])

  useEffect(() => {
    onReachBottomRef.current = onReachBottom
  }, [onReachBottom])

  const { run } = useDebounceFn(
    () => {
      if (!loadFinishRef.current && !loadingRef.current && onReachBottomRef.current) {
        onReachBottomRef.current()
      }
    },
    {
      wait: 100
    }
  )

  const handleScroll = useCallback(() => {
    // 获取文档滚动信息
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = window.innerHeight
    const distanceToBottom = scrollHeight - scrollTop - clientHeight

    // 当距离底部小于 200px 时触发加载
    if (scrollTop > 0 && distanceToBottom < 200) {
      run()
    }
  }, [run])

  useEffect(() => {
    // 监听 window 滚动事件
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  useImperativeHandle(ref, () => ({
    scrollTop: () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    scrollToElement: (element, offset = 0) => {
      if (element) {
        const elementRect = element.getBoundingClientRect()
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const targetScrollTop = scrollTop + elementRect.top + offset
        window.scrollTo({
          top: targetScrollTop,
          behavior: 'smooth'
        })
      }
    }
  }))

  return (
    <div className="scoll-load" ref={ scrollLoadRef }>
      <div className="scroll-wrap" ref={ scrollWrapRef }>
        <div className="children-wrap">
          { children }
        </div>
      </div>
      <FloatButton.BackTop
        ref={ backTopRef }
        visibilityHeight={ 500 }
        duration={100}
      />
    </div>
  )
})

export default ScrollLoad
